import React,{useEffect,useState} from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import PersonIcon from '@material-ui/icons/Person';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import Chart from '../component/chart';
import Deposits from '../component/Deposits.js';
import Orders from '../component/Orders';
import Sidebar from '../component/Sidebar';
import Bread from '../component/Breadcrumbs';
import Card from '../component/Card';
import {AuthData} from '../Services/Authdata';
import {UserList} from '../Services/User'
import HomeIcon from '@material-ui/icons/Home';



function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Yornee.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },

  container: {
    marginTop:'20px',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Dashboard() {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [dash, setDash] = useState({
    'user':0,
    'trip':0,
    'recent_amount':0,
    'chart':[],
    'confirmedBooking':0,
    'booking':0,
    'flights':0,
    'totalMonthRevenue':0
  });
  useEffect(() =>{

    UserList('dashboard','GET',AuthData().token).then((result)=>{
      //console.log(result);
      setDash({
        'user':result.data.user,
        'trip':result.data.trip,
        'recent_amount':result.data.todayRevenue,
        'chart':result.data.chart,
        'confirmedBooking':result.data.confirmedBooking,
        'flights':result.data.flights,
        'booking':result.data.booking,
        'totalMonthRevenue':result.data.totalMonthRevenue
      });
      //console.log(dash)
    })
  },[])
const br = [{
  'title':'Home',
  'icon':<HomeIcon fontSize="small" />,
  'url':'/dashboards'
}];
  return (
    <div className={classes.root}>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      
        <Container maxWidth="lg" className={classes.container} style={{marginTop:'4%'}}>
        <Bread data={br}/>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4} lg={3}>
              <Card title={'Total User'} data={dash.user} icon={<PersonIcon fontSize="large" />}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Card title={'Total Hotel Booking'} data={dash.confirmedBooking} icon={<MonetizationOnIcon  fontSize="large"/>}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Card title={'Total Sales'} data={dash.totalMonthRevenue} icon={<TrendingDownIcon  fontSize="large"/>}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Card title={'Total Flights'} data={dash.flights} icon={<CardTravelIcon  fontSize="large"/>}/>
            </Grid>
            {/* Chart */}
            <Grid item xs={12} md={8} lg={9}>
              <Paper className={fixedHeightPaper}>
                <Chart data={dash.chart} />
              </Paper>
            </Grid>
            {/* Recent Deposits */}
            <Grid item xs={12} md={4} lg={3}>
              <Paper className={fixedHeightPaper}>
                <Deposits data={dash.recent_amount}/>
              </Paper>
            </Grid>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Orders />
              </Paper>
            </Grid>
          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
      
  );
}


// WEBPACK FOOTER //
// ./src/Pages/Dashboard.js